import apiClient from './core/http/clients/apiClient';
import hdsClient from "./core/http/clients/hdsClient";
import StorageService from "./core/services/StorageService";
import AuthenticationService from "./core/services/AuthenticationService";
import HostResource from "./core/http/resources/HostResource";
import EnvironmentResource from "./core/http/resources/EnvironmentResource";
import NotificationResource from "./core/http/resources/NotificationResource";
import {createClient as contentfulCreateClient} from "contentful";
import ContentfulService from "./core/services/ContentfulService";
import ExperienceResource from "./core/http/resources/ExperienceResource";
import CustomerResource from "./core/http/resources/customer/CustomerResource";
import ExtensionResource from "./core/http/resources/ExtensionResource";
import OrderResource from "./core/http/resources/OrderResource";
import TeamResource from "./core/http/resources/TeamResource";
import TeamPlanningResource from "./core/http/resources/TeamPlanningResource";
import SecureFileResource from "./core/http/resources/SecureFileResource";
import ProgramResource from "./core/http/resources/ProgramResource";
import LoyaltyCardMembershipResource from "./core/http/resources/loyalty-card/LoyaltyCardMembershipResource";
import CustomerProgramResource from "./core/http/resources/customer/CustomerProgramResource";
import CustomerQrCodeResource from "./core/http/resources/customer/CustomerQrCodeResource";
import MedicineCabinetResource from "./core/http/resources/MedicineCabinetResource";
import PrescriptionResource from "./core/http/resources/PrescriptionResource";
import LoyaltyCardResource from "./core/http/resources/loyalty-card/LoyaltyCardResource";
import LoyaltyCardMembershipTransactionResource
    from "./core/http/resources/loyalty-card/LoyaltyCardMembershipTransactionResource";
import LoyaltyCardMembershipRewardResource
    from "./core/http/resources/loyalty-card/LoyaltyCardMembershipRewardResource";
import LoyaltyCardMembershipCreditResource
    from "./core/http/resources/loyalty-card/LoyaltyCardMembershipCreditResource";
import SurveyResource from "./core/http/resources/survey/SurveyResource";
import SurveyBundleResource from "./core/http/resources/survey/SurveyBundleResource";
import SurveyAnswerInstanceResource from "./core/http/resources/survey/SurveyAnswerInstanceResource";
import NotificationTemplateResource from "./core/http/resources/NotificationTemplateResource";
import OrganizationCreditResource from "./core/http/resources/OrganizationCreditResource";
import ProgramAttachmentResource from "./core/http/resources/ProgramAttachmentResource";
import GuidanceResource from "./core/http/resources/GuidanceResource";
import PathwayResource from "./core/http/resources/PathwayResource";
import DocumentResource from "./core/http/resources/DocumentResource";
import ProductResource from "./core/http/resources/ProductResource";
import HospitalFileResource from "./core/http/resources/HospitalFileResource";
import HealthcenterUserResource from "@/core/http/resources/healthcenter/HealthcenterUserResource";
import InstantDiscountVoucherResource from "@/core/http/resources/InstantDiscountVoucherResource";
import DetectionResource from "@/core/http/resources/DetectionResource";
import InterviewResource from "@/core/http/resources/InterviewResource";
import ConsumerCartResource from "@/core/http/resources/ConsumerCartResource";
import DrugInteractionResource from "@/core/http/resources/DrugInteractionResource";
import ConsumerProductResource from "@/core/http/resources/ConsumerProductResource";
import DisruptionLogisticsResource from "@/core/http/resources/DisruptionLogisticsResource";
import WholesalerResource from "@/core/http/resources/WholesalerResource";
import SponsorshipResource from "@/core/http/resources/SponsorshipResource";
import SanteSecureResource from "@/core/http/resources/SanteSecureResource";
import SecureMessagingResource from "@/core/http/resources/SecureMessagingResource";
import UsersResource from "@/core/http/resources/UsersResource";
import ProSanteConnectResource from "@/core/http/resources/ProSanteConnectResource";
import RegistrationService from "@/core/services/RegistrationService";
import GroupingsResource from "@/core/http/resources/GroupingsResource";
import LgoResource from "@/core/http/resources/LgoResource";
import HealthcenterSearchResource from "@/core/http/resources/healthcenter/HealthcenterSearchResource";
import OfferResource from "@/core/http/resources/OfferResource";
import OfferTeaserResource from "@/core/http/resources/OfferTeaserResource";
import HealthcenterProductResource from "@/core/http/resources/healthcenter/HealthcenterProductResource";
import FilemanagerFileResource from "@/core/http/resources/FilemanagerFileResource";
import SubscriptionPlanResource from "@/core/http/resources/subscription-plan/SubscriptionPlanResource";
import HealthcenterResource from "@/core/http/resources/healthcenter/HealthcenterResource";
import MassCertificationResource from "@/core/http/resources/MassCertificationResource";
import CreditResource from "@/core/http/resources/CreditResource";
import StripeResource from "@/core/http/resources/stripe/StripeResource";
import StripeConnectResource from "@/core/http/resources/stripe/StripeConnectResource";
import PrescriptionRenewalPlanResource, {
    PrescriptionRenewalPlanResourceInterface
} from "@/core/http/resources/PrescriptionRenewalPlanResourceInterface";
import DisruptionResource from "@/core/http/resources/disruptionResource";
import ShopResource from "@/core/http/resources/ShopResource";
import TaskResource from "@/core/http/resources/TaskResource";
import LaboratoryResource from "@/core/http/resources/laboratory/LaboratoryResource";
import KnowledgeBoxResource from "@/core/http/resources/KnowledgeBoxResource";
import AiAssistantResource from "@/core/http/resources/AiAssistantResource";
import HealthJourneyResource from "@/core/http/resources/HealthJourneyResource";
import BackingResource from "@/core/http/resources/BackingResource";
import SearchBarResource from "@/core/http/resources/SearchBarResource";
import PrescriptionAnalysisResource from "@/core/http/resources/PrescriptionAnalysisResource";
import NotificationSequenceResource from "@/core/http/resources/notification-sequence/NotificationSequenceResource";
import AdvantageResource from "@/core/http/resources/advantage/AdvantageResource";
import VideoResource from "@/core/http/resources/video/VideoResource";
import ContractResource from "@/core/http/resources/ContractResource";
import AlertResource from "@/core/http/resources/alert/AlertResource";
import ShellUpdateResource from "@/core/http/resources/shell-update/ShellUpdateResource";
import LiveServiceResource from "@/core/http/resources/live-service/LiveServiceResource";
import {StorageService as StorageServiceInterface} from "@/core/services/StorageService";
import AttachmentResource from "@/core/http/resources/attachment/AttachmentResource";
import SharingResource from "@/core/http/resources/sharing/SharingResource";
import ApodisCoinResource from "@/core/http/resources/ApodisCoinResource";
import AppointmentResource from "@/core/http/resources/AppointmentResource";
import AppointmentTypeResource from "@/core/http/resources/AppointmentTypeResource";
import BookingLinkPresetResource from "@/core/http/resources/BookingLinkPresetResource";
import TeamTaskResource from "@/core/http/resources/TeamTaskResource";
import AgendaResource from "@/core/http/resources/AgendaResource";
import FrequentationResource from "@/core/http/resources/FrequentationResource";
import SupportProgramResource from "@/core/http/resources/SupportProgramResource";
import ConsumerHospitalResource from "@/core/http/resources/hospitals/ConsumerHospitalResource";
import AsafoResource from "@/core/http/resources/asafo/AsafoResource";
import ReconciliationResource from "@/core/http/resources/consumer-reconciliation/ReconciliationResource";
import FlowchartResource from "@/core/http/resources/flowchart/FlowchartResource";
import OrganizationResource from "@/core/http/resources/OrganizationResource";
import TrackerResource from "@/core/http/resources/TrackerResource";
import FlowchartInstanceResource from "@/core/http/resources/flowchart/FlowchartInstanceResource";
import DosageResource from "@/core/http/resources/dosage/DosageResource";
import VersionResource from "@/core/http/resources/version/VersionResource";
import ContestResource from "@/core/http/resources/contest/ContestResource";
import BirthdayGiftResource from "@/core/http/resources/birthday-gift/BirthdayGiftResource";
import CityResource from "@/core/http/resources/CityResource";
import PollResource from "@/core/http/resources/PollResource";
import PetResource from "@/core/http/resources/PetResource";
import ConsumerCacheResource from "@/core/http/resources/customer/ConsumerCacheResource";
import ConsumerDetailsResource from "@/core/http/resources/customer/ConsumerDetailsResource";
import ActResource from "@/core/http/resources/ActResource";
import MedicationCheckupResource from "@/core/http/resources/medication-checkup/MedicationCheckupResource";
import ConversationResource from "@/core/http/resources/ConversationResource";
import VaccinationResource from "@/core/http/resources/VaccinationResource";
import FeatureHighlightResource from "@/core/http/resources/feature-highlight/FeatureHighlightResource";
import RcsResource from "@/core/http/resources/rcs/RcsResource";
import MetricsResource from "@/core/http/resources/MetricsResource";
import ReferralResource from "@/core/http/resources/referral/ReferralResource";

/**
 * Bind the storage service.
 * @returns The storage service.
 */
export function storageService(): StorageServiceInterface {
    return StorageService();
}

/**
 * Bind the authentication service.
 * @returns The authentication service.
 */
export function authenticationService() {
    return AuthenticationService(apiClient, storageService());
}

/**
 * Bind the host resource.
 * @returns The host resource.
 */
export function hostApi() {
    return HostResource(apiClient);
}

/**
 * Bind the environment resource.
 * @returns The environment resource.
 */
export function environmentApi() {
    return EnvironmentResource(apiClient);
}

/**
 * Bind the notification resource.
 * @returns The notification resource.
 */
export function notificationApi() {
    return NotificationResource(apiClient);
}

/**
 * Bind the contentful service.
 * @returns The contentful service.
 */
export function contentfulService() {
    return ContentfulService(contentfulCreateClient);
}

/**
 * Bind the Experience resource.
 *
 * @returns The experience resource.
 */
export function experienceApi() {
    return ExperienceResource(apiClient);
}

/**
 * Bind the customer resource.
 * @returns The customer resource.
 */
export function customerApi() {
    return CustomerResource(hdsClient);
}

/** Bind the Asafo resource.*/
export function asafoApi() {
    return AsafoResource(hdsClient);
}

/** Bind the flowchart resource.*/
export function flowchartApi() {
    return FlowchartResource(apiClient);
}

/** Bind the flowchart instance resource.*/
export function flowchartInstanceApi() {
    return FlowchartInstanceResource(apiClient);
}

/** Bind the consumer reconciliation resource.*/
export function reconciliationApi() {
    return ReconciliationResource(hdsClient);
}

/** Bind the consumer cache resource.*/
export function consumerCacheApi() {
    return ConsumerCacheResource(hdsClient);
}

/** Bind the consumer details resource. */
export function consumerDetailsApi() {
    return ConsumerDetailsResource(hdsClient);
}

/**
 * Bind the customer program resource.
 * @returns The customer program resource.
 */
export function customerProgramApi() {
    return CustomerProgramResource(apiClient);
}

/**
 * Bind the customer QR code resource.
 * @returns The customer QR code resource.
 */
export function customerCertificationApi() {
    return CustomerQrCodeResource(hdsClient);
}

/**
 * Bind the extension resource.
 *
 * @returns The extension resource.
 */
export function extensionApi() {
    return ExtensionResource(apiClient);
}

/**
 * Bind the order resource.
 *
 * @returns The order resource.
 */
export function orderApi() {
    return OrderResource(hdsClient);
}

/**
 * Bind the team resource.
 *
 * @returns The team resource.
 */
export function teamApi() {
    return TeamResource(apiClient);
}

/**
 * Bind the team planning resource.
 *
 * @returns The team planning resource.
 */
export function teamPlanningApi() {
    return TeamPlanningResource(apiClient);
}

/**
 * Bind the secure file resource.
 *
 * @returns The secure file resource.
 */
export function secureFileApi() {
    return SecureFileResource(hdsClient);
}

/**
 * Bind the program resource.
 * @returns The program resource.
 */
export function programApi() {
    return ProgramResource(apiClient, hdsClient);
}

/**
 * Bind the knowledge box resource.
 * @returns The knowledge box resource.
 */
export function knowledgeBoxApi() {
    return KnowledgeBoxResource(apiClient);
}

/**
 * Bind the AI assistant resource.
 *
 * @returns The AI assistant resource.
 */
export function aiAssistantApi() {
    return AiAssistantResource(apiClient);
}

/**
 * On the main API: a journey proposal is acts, durations and moments, and the
 * counter never sends who it is for.
 */
export function healthJourneyApi() {
    return HealthJourneyResource(apiClient);
}

/**
 * Bind the hospital file resource.
 *
 * @returns The hospital file resource.
 */
export function hospitalFileApi() {
    return HospitalFileResource(hdsClient);
}

/**
 * Bind the consumer hospital api.
 */
export function consumerHospitalApi() {
    return ConsumerHospitalResource(hdsClient);
}

/**
 * Bind the loyalty card membership resource.
 * @returns The loyalty card membership resource.
 */
export function loyaltyCardMembershipApi() {
    return LoyaltyCardMembershipResource(hdsClient);
}

/**
 * Bind the medicine cabinet resource.
 *
 * @returns The medicine cabinet resource.
 */
export function medicineCabinetApi() {
    return MedicineCabinetResource(hdsClient);
}

/**
 * Bind the prescription resource.
 *
 * @returns The prescription resource.
 */
export function prescriptionApi() {
    return PrescriptionResource(hdsClient);
}

/**
 * Bind the posos api resource.
 *
 * @returns The prescription analysis resource.
 */
export function prescriptionAnalysisApi() {
    return PrescriptionAnalysisResource(hdsClient);
}

/**
 * Bind the prescription renewal plan resource.
 *
 * @returns The prescription renewal plan resource.
 */
export function prescriptionRenewalPlanApi(): PrescriptionRenewalPlanResourceInterface {
    return PrescriptionRenewalPlanResource(hdsClient);
}

/**
 * Bind the loyalty card resource.
 * @returns The loyalty card resource.
 */
export function loyaltyCardApi() {
    return LoyaltyCardResource(apiClient, hdsClient);
}

/**
 * Bind the loyalty card membership transaction resource.
 * @returns The loyalty card membership transaction resource.
 */
export function loyaltyCardMembershipTransactionApi() {
    return LoyaltyCardMembershipTransactionResource(hdsClient);
}

/**
 * Bind the loyalty card membership reward resource.
 * @returns The loyalty card membership reward resource.
 */
export function loyaltyCardMembershipRewardApi() {
    return LoyaltyCardMembershipRewardResource(hdsClient);
}

/**
 * Bind the loyalty card membership credit resource.
 * @returns The loyalty card membership credit resource.
 */
export function loyaltyCardMembershipCreditApi() {
    return LoyaltyCardMembershipCreditResource(hdsClient);
}

/**
 * Bind the survey resource.
 *
 * @returns The survey resource.
 */
export function surveyApi() {
    return SurveyResource(apiClient, hdsClient);
}

/**
 * Bind the survey bundle resource.
 *
 * @returns The survey bundle resource.
 */
export function surveyBundleApi() {
    return SurveyBundleResource(apiClient);
}

/**
 * Bind the survey answer instance resource.
 * As some endpoint need authorization check we need to use the hds client.
 * Often, the request is forwarded to the api.
 *
 * @returns The survey answer instance resource.
 */
export function surveyAnswerInstanceApi() {
    return SurveyAnswerInstanceResource(apiClient, hdsClient);
}

/**
 * Bind the message template resource.
 * @returns The notification template resource.
 */
export function notificationTemplateApi() {
    return NotificationTemplateResource(hdsClient);
}

/**
 * Bind the organization credit resources.
 *
 * @returns The organization credit resource.
 */
export function organizationCreditApi() {
    return OrganizationCreditResource(apiClient);
}

/**
 * Bind the program attachment resource.
 *
 * @returns The program attachment resource.
 */
export function programAttachmentApi() {
    return ProgramAttachmentResource(apiClient);
}

/**
 * Bind the guidance api.
 *
 * @returns The guidance resource.
 */
export function guidanceApi() {
    return GuidanceResource(apiClient, hdsClient);
}

/**
 * Bind the pathway api.
 *
 * @returns The pathway resource.
 */
export function pathwayApi() {
    return PathwayResource(apiClient);
}

/**
 * Bind the document api.
 *
 * @returns The document resource.
 */
export function documentApi() {
    return DocumentResource(apiClient);
}

/**
 * Bind the product resource.
 *
 * @returns The product resource.
 */
export function productApi() {
    return ProductResource(apiClient, hdsClient);
}

/**
 * Bind the healthcenter user resource.
 *
 * @returns The healthcenter user resource.
 */
export function healthcenterUserApi() {
    return HealthcenterUserResource(hdsClient);
}

/**
 * Bind the instant discount voucher resource.
 * @returns The instant discount voucher resource.
 */
export function instantDiscountVoucherApi() {
    return InstantDiscountVoucherResource(apiClient, hdsClient);
}

/**
 * Bind the detection resource.
 * @returns The detection resource.
 */
export function detectionApi() {
    return DetectionResource(hdsClient);
}

/**
 * Bind the interview resource.
 */
export function interviewApi() {
    return InterviewResource(apiClient, hdsClient);
}

/**
 * Bind the filemanager file resource.
 */
export function filemanagerFileApi() {
    return FilemanagerFileResource(apiClient);
}

/**
 * Bind the customer cart resource.
 *
 * @returns The consumer cart resource.
 */
export function consumerCartApi() {
    return ConsumerCartResource(hdsClient);
}

/**
 * Bind the customer product resource.
 *
 * @returns The consumer product resource.
 */
export function consumerProductApi() {
    return ConsumerProductResource(apiClient, hdsClient);
}

/**
 * Bind the drug interaction resource.
 *
 * @returns The drug interaction resource.
 */
export function drugInteractionApi() {
    return DrugInteractionResource(apiClient, hdsClient);
}

/**
 * Bind the disruption logistics resource.
 */
export function disruptionLogisticsApi() {
    return DisruptionLogisticsResource(apiClient);
}

/**
 * Bind the wholesaler resource.
 */
export function wholesalerApi() {
    return WholesalerResource(apiClient);
}

/**
 * Bind the sponsorship resource.
 */
export function sponsorshipApi() {
    return SponsorshipResource(apiClient);
}

/**
 * Bind the sante-secure resource.
 * @returns The sante secure resource.
 */
export function santeSecureApi() {
    return SanteSecureResource(apiClient);
}

/**
 * Bind the secure messaging (MSSanté) resource.
 * @returns The secure messaging resource.
 */
export function secureMessagingApi() {
    return SecureMessagingResource(apiClient, hdsClient);
}

/**
 * Bind the users resource.
 * @returns The users resource.
 */
export function usersApi() {
    return UsersResource(apiClient);
}

/**
 * Bind the pro sante connect resource.
 * @returns The pro sante connect resource.
 */
export function proSanteConnectApi() {
    return ProSanteConnectResource(apiClient);
}

/**
 * Bind the registration service.
 * @returns The registration service.
 */
export function registrationService() {
    return RegistrationService(apiClient);
}

/**
 * Bind the groupings resource.
 * @returns The groupings resource.
 */
export function groupingsApi() {
    return GroupingsResource(apiClient);
}

/**
 * Bind the lgo resource.
 * @returns The lgo resource.
 */
export function lgoApi() {
    return LgoResource(apiClient);
}

/**
 * Bind the healthcenter search resource.
 * @returns The healthcenter search resource.
 */
export function healthcenterSearchApi() {
    return HealthcenterSearchResource(apiClient);
}

/**
 * Bind the healthcenter product resource.
 * @returns The healthcenter product resource.
 */
export function healthcenterProductApi() {
    return HealthcenterProductResource(apiClient);
}

/**
 * Bind the offer resource.
 * @returns The offer resource.
 */
export function offerApi() {
    return OfferResource(apiClient);
}

/**
 * Bind the offer teaser resource.
 * @returns The offer teaser resource.
 */
export function offerTeaserApi() {
    return OfferTeaserResource(apiClient);
}

/**
 * Bind the subscription plan resource.
 */
export function subscriptionPlanApi() {
    return SubscriptionPlanResource(apiClient);
}

/**
 * Bind the healthcenter resource.
 */
export function healthcenterApi() {
    return HealthcenterResource(apiClient);
}

/**
 * Bind the mass certification resource.
 */
export function massCertificationApi() {
    return MassCertificationResource(hdsClient);
}

/**
 * Bind the credit resource.
 */
export function creditApi() {
    return CreditResource(apiClient);
}

/**
 * Bind the stripe resource.
 */
export function stripeApi() {
    return StripeResource(apiClient);
}

/**
 * Bind the stripe connect resource.
 */
export function stripeConnectApi() {
    return StripeConnectResource(apiClient);
}

/**
 * Bind the disruption resource.
 */
export function disruptionApi() {
    return DisruptionResource(apiClient);
}

/**
 * Bind the shop resource.
 */
export function shopApi() {
    return ShopResource(apiClient);
}

/**
 * Bind the laboratory resource.
 */
export function laboratoryApi() {
    return LaboratoryResource(apiClient, hdsClient);
}

/**
 * Bind the task resource.
 */
export function taskApi() {
    return TaskResource(hdsClient);
}

/**
 * Bind the backing resource.
 */
export function backingApi() {
    return BackingResource(apiClient, hdsClient);
}

/**
 * Bind the search bar resource.
 */
export function searchBarApi() {
    return SearchBarResource(apiClient);
}

/**
 * Bind the notification sequence resource.
 */
export function notificationSequenceApi() {
    return NotificationSequenceResource(apiClient, hdsClient);
}

/**
 * Bind the video resource.
 */
export function videoApi() {
    return VideoResource(apiClient);
}

/**
 * Bind the alert resource.
 */
export function alertApi() {
    return AlertResource(apiClient);
}

/**
 * Bind the shell update resource.
 */
export function shellUpdateApi() {
    return ShellUpdateResource(apiClient);
}

/**
 * Bind the Apodis Live service resource.
 */
export function liveServiceApi() {
    return LiveServiceResource(apiClient);
}

export function contractApi() {
    return ContractResource(apiClient);
}

/**
 * Bind the advantage api.
 */
export function advantageApi() {
    return AdvantageResource(apiClient);
}

/**
 * Bind the attachment api.
 */
export function attachmentApi() {
    return AttachmentResource(apiClient);
}

/**
 * Bind the sharing api.
 */
export function sharingApi() {
    return SharingResource(hdsClient);
}

/**
 * Bind the apodis coin api.
 */
export function apodisCoinApi() {
    return ApodisCoinResource(apiClient);
}

export function appointmentApi() {
    return AppointmentResource(hdsClient);
}

/**
 * Bind the appointment type resource.
 */
export function appointmentTypeApi() {
    return AppointmentTypeResource(apiClient);
}

/**
 * Bind the agenda resource.
 */
export function agendaApi() {
    return AgendaResource(hdsClient);
}

/**
 * Bind the booking link preset resource.
 */
export function bookingLinkPresetApi() {
    return BookingLinkPresetResource(apiClient, hdsClient);
}

/**
 * Bind the team task resource.
 *
 * On the HDS: a task carries free text where patient data may be written.
 */
export function teamTaskApi() {
    return TeamTaskResource(hdsClient);
}

/**
 * Bind the frequentation resource.
 */
export function frequentationApi() {
    return FrequentationResource(hdsClient);
}

export function supportProgramApi() {
    return SupportProgramResource(apiClient);
}

export function organizationApi() {
    return OrganizationResource(apiClient);
}

/**
 * Bind the dosage api.
 */
export function dosageApi() {
    return DosageResource(hdsClient, apiClient);
}

/**
 * Bind the tracker api.
 */
export function trackerApi() {
    return TrackerResource(apiClient);
}

/**
 * Bind the version api.
 */
export function versionApi() {
    return VersionResource(apiClient);
}

/**
 * Bind the contest api.
 */
export function contestApi() {
    return ContestResource(hdsClient);
}

/**
 * Bind the poll api.
 */
export function pollApi() {
    return PollResource(apiClient, hdsClient);
}

/**
 * Bind the pet api.
 */
export function petApi() {
    return PetResource(hdsClient);
}

/**
 * Bind the city api.
 */
export function cityApi() {
    return CityResource(apiClient);
}

export function actApi() {
    return ActResource(apiClient);
}

/**
 * Bind the conversation api.
 */
export function conversationApi() {
    return ConversationResource(hdsClient);
}

/**
 * Bind the vaccination api.
 */
export function vaccinationApi() {
    return VaccinationResource(hdsClient);
}

/**
 * Bind the feature highlight api.
 */
export function featureHighlightApi() {
    return FeatureHighlightResource(apiClient);
}

/**
 * Bind the rcs api.
 */
export function rcsApi() {
    return RcsResource(hdsClient);
}

export function metricsApi() {
    return MetricsResource(apiClient);
}

/**
 * Bind the referral resource.
 */
export function referralApi() {
    return ReferralResource(apiClient);
}

/**
 * Bind the birthday gift api.
 */
export function birthdayGiftApi() {
    return BirthdayGiftResource(hdsClient);
}

/**
 * Bind the medication checkup api (BPM Copilote).
 *
 * The BPM is served by the HDS alone, so it is bound to the hds client.
 */
export function medicationCheckupApi() {
    return MedicationCheckupResource(hdsClient);
}
